import React from "react";

export const AuthContinue = (props) => {
  const onClickFunction = props.onClickFunction ? props.onClickFunction : null;

  return (
    <button
      className="mt-5 button primary full auth-continue"
      disabled={props.disabled}
      onClick={onClickFunction}
      type={props.type}
      data-e2e-id="continueButton"
    >
      {props.title}
    </button>
  );
};



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/misc/auth-continue.component.js